export default {
  BASE_URL: "psm/sp/config/",
  api: [
    {
      name: "list",
      desc: "申报配置-列表v1.3",
      method: "GET",
      path: "list"
    },
    {
      name: "year",
      desc: "申报年份下拉框-v1.3",
      method: "GET",
      path: "year"
    },
    {
      name: "enable",
      desc: "启用/关闭申报配置-v1.3",
      method: "POST",
      path: "enable"
    },
    {
      name: "delete",
      desc: "删除申报配置-v1.3",
      method: "GET",
      path: "delete"
    },
    {
      name: "query",
      desc: "申报配置-查询详情v1.3",
      method: "GET",
      path: "query"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/psm/sp/config.js